<script>
	import { Radar,Charts } from 'vue-chartjs'


	export default {
        extends: Radar,

        data () {
            return {
                //
                chart_options: {
                    scale: {
                        ticks: {
                            beginAtZero: true,
                            // min: 0,
                            // max: parseInt(this.range.max)
                        }
                    },
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: this.title_text
                    },
                    responsive: true,
                    maintainAspectRatio: false
                    },
                datas: this.datas_bar
            }
        },
        mounted () {
          if (this.static_chart_data.labels.length > 0){
            this.drawRadarGraph(this.static_chart_data);
          }
        },
        methods: {
            drawRadarGraph(datas_bar){
                let componentGraph = this;
                componentGraph.renderChart(datas_bar, componentGraph.chart_options)
            },
        },
        props: {

            static_chart_data : {
              type:Object,
              required:false,
              default() {
                return {
                  labels: [],
                  datasets: []
                }
              }

            },

            range:{
                type:Object,
                required:true
            },

            title_text:{
                type:String,
                required:false,
                default : 'Performance'
            }
        }

    }
</script>
